/**
 * App-level providers for apps/admin.
 *
 * Wraps the tree with TanStack Query and react-intl (SCRUM-236 — Sparta's
 * first i18n provider; see `shared/i18n`). Sentry is initialised eagerly via
 * `initSentry` in main.tsx; no provider needed since Sentry uses a global
 * singleton.
 *
 * @serg-erin review 2026-05-11: the `queryClient` singleton now lives
 * at `shared/query-client.ts` so widgets / shared hooks can consume
 * it without crossing the `fe-widgets → fe-app` boundary. This file
 * is the React provider wrapper only — bootstrap-layer per ADR
 * frontend-0001.
 */

import * as React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '../shared/query-client.js';
import { AppIntlProvider } from '../shared/i18n/index.js';

export function AppProviders(props: { children: React.ReactNode }): React.ReactElement {
  return (
    <QueryClientProvider client={queryClient}>
      <AppIntlProvider>{props.children}</AppIntlProvider>
    </QueryClientProvider>
  );
}
